import { t } from 'i18next';
import { isEmpty } from 'lodash';
import { Trans } from 'react-i18next';
import type { Location } from '../../domain/models/locations/Location';
import { ReactComponent as AlbumIcon } from '../../icons/album.svg';
import { ReactComponent as LeaderIcon } from '../../icons/leader.svg';
import { snakeToCamel } from '../../utils/TextUtil';

const FootprintSection = ({ pos, isListItem }: { pos: Location; isListItem?: boolean }) => {
  let baseImageUrl = '';
  let authorName = '';
  let authorId = '';
  let footprinterName = '';

  if (pos.externalSources?.length) {
    const externalSource = pos.externalSources[0];
    baseImageUrl = externalSource.baseImageUrl();
    authorId = externalSource.author || '';
    authorName = externalSource.author || '';
    footprinterName = externalSource.getArtistMemberNames();
  }

  if (pos.footprints?.length) {
    const footprint = pos.footprints[0];
    baseImageUrl = footprint.baseThumbnailUrl ?? baseImageUrl;
    footprinterName = footprint.footprinterName || footprinterName;
    authorName = footprint.reporter?.nickname || authorName;
    authorId = authorName;
  }

  const containerClassName = `flex flex-row gap-[14px] items-center ${
    isListItem // 만약 isListItem이 true이면 (리스트 아이템)
      ? 'px-[16px]' // ➡️ 'px-[16px]' 클래스가 붙어! (라이트/다크 상관없이 16px!) ✨
      : '' // isListItem이 false이면 (모달) ➡️ 빈 문자열이 붙어! (라이트/다크 상관없이 패딩 없음!) ✨
  }`;

  // const containerClassName = `flex flex-row gap-[14px] items-center ${
  //   isListItem // 만약 isListItem이 true이면
  //     ? 'px-[16px]' // 라이트/다크 모드 상관없이 항상 px-[16px] 적용!
  //     : 'dark:px-[16px]' // isListItem이 false이면 (모달), 다크 모드일 때만 px-[16px] 적용!
  // }`;

  return (
    // <div className = "flex flex-row gap-[14px] items-center">
    <div className={containerClassName}>
      <div className="rounded-[7px] w-[93px] h-[66px] aspect-[93/66] flex items-center justify-center bg-surface-lightLv2 dark:bg-surface-darkLv2">
        {baseImageUrl ? (
          <img
            src={baseImageUrl}
            alt={footprinterName}
            className="rounded-[7px] w-[93px] h-[66px] aspect-[93/66] object-cover"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
            }}
          />
        ) : (
          <AlbumIcon className="w-[20px] h-[20px] fill-disabled-light dark:fill-disabled-dark" />
        )}
      </div>

      <div className="flex flex-col justify-between h-[66px]">
        <div
          className={`font-semibold text-[15px] ${
            pos.footprints?.length
              ? 'text-main-light-2 dark:text-main-dark-2'
              : 'text-main-light-1 dark:text-main-dark-1'
          }`}
        >
          {pos.footprints?.length ? (
            <Trans
              i18nKey="OfflineLocation.footrpintTitle"
              components={{
                bold: <span className="text-textPrimary-light dark:text-textPrimary-dark" />
              }}
              values={{ artist: footprinterName }}
            />
          ) : (
            <Trans
              i18nKey="OfflineLocation.tweetTitle"
              values={{ author: authorName, artist: footprinterName }}
            />
          )}
        </div>

        <div className="flex flex-row items-center text-main-light-4 dark:text-main-dark-4 text-[13px] truncate">
          {t(`LocationCategory.${snakeToCamel(pos.category)}`)}
          <span className="mx-[5px]">{' ･ '}</span>

          <LeaderIcon className="mr-1 w-[14px] h-[14px] fill-current" />
          {isEmpty(authorId) ? t('FootprintsSection.anonymous') : authorId}
        </div>
      </div>
    </div>
  );
};

export default FootprintSection;
